import { createStyles } from "@mantine/emotion";

export const useStylesProviders = createStyles((theme) => ({
  providers: {
    ".text": {
      fontSize: theme.spacing.providers.fontSize.text,
      fontWeight: "normal",
      textAlign: "center",
      maxWidth: theme.spacing.providers.maxWidth.text,
      marginLeft: "auto",
      marginRight: "auto",
    },
    ".content": {
      backgroundColor: theme.customColors.white,
      borderRadius: theme.spacing.providers.borderRadius.content,
      maxWidth: theme.spacing.providers.maxWidth.content,
      padding: theme.spacing.providers.padding.content,
      marginLeft: "auto",
      marginRight: "auto",
    },
    h4: {
      paddingBottom: theme.spacing.providers.padding.bottom.heading,
    },
    ".provider-button": {
      marginBottom: theme.spacing.providers.margin.bottom.button,
    },
    ".provider-name-input": {
      maxWidth: theme.spacing.providers.maxWidth.input,
    },
    ".provider-name-error-text": {
      fontSize: theme.spacing.providers.fontSize.error,
      lineHeight: theme.spacing.providers.lineHeight.error,
      color: theme.customColors.red,
      fontFamily: theme.headings.fontFamily.light,
    },
    ".provider-submit": {
      marginTop: theme.spacing.providers.margin.top.modal,
    },
    ".loader": {
      minHeight: theme.spacing.providers.minHeight.loader,
    },
  },
  list: {
    marginBottom: theme.spacing.providers.margin.bottom.list,
    li: {
      marginBottom: theme.spacing.providers.margin.bottom.item,
      borderBottom: "1px solid " + theme.customColors.black,
      paddingBottom: theme.spacing.providers.padding.bottom.item,
      "&:last-child": {
        border: "none",
      },
      ".mantine-Text-root": {
        fontFamily: theme.headings.fontFamily.bold,
        color: theme.customColors.black,
        span: {
          fontFamily: theme.headings.fontFamily.light,
          color: theme.customColors.black,
        },
      },
      ".error": {
        color: theme.customColors.red,
      },
    },
  },
  ProvidersModalText: {
    fontSize: theme.spacing.providers.fontSize.modal,
    textAlign: "center",
    marginTop: theme.spacing.providers.margin.top.modal,
    marginBottom: theme.spacing.providers.margin.top.modal,
  },
}));
